(function() {
    if (window.location.pathname == "/" && window.location.search.indexOf("oseid=") > -1) {
        // 편집기 모드일 경우 리다이렉트 중단
        return;
    }

    // URLSearchParams를 사용해 현재 URL에서 mode 파라미터가 있는지 확인
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('mode')) {
      // mode 파라미터가 있으면 함수 종료 (리다이렉트 중단)
      return;
    }

    // 정상적인 CORS 헤더를 제공하는 IP API 로 변경해야 함
    var url = "https://ipinfo.io/json"; // 예시: 서비스 정책 확인 필수

    fetch(url, { method: "GET" })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var country = data.country; // 예: "DE"

        var EU_COUNTRIES = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE","GB","NO","CH","RU","AL","UA"];

	if (EU_COUNTRIES.indexOf(country) == -1) {
          window.location.href = 'https://www.cosmerna.com/?mode=redirect';
        }
      })
      .catch(function(err) {
        // 실패 시 그냥 글로벌에 둠
        console.error("Geo IP error", err);
      });
  })();